<app-splash-screen></app-splash-screen>
<router-outlet></router-outlet>
<!-- <app-expire-token-model></app-expire-token-model> -->
 <!-- <div *ngIf="showBar" 
    style="background-color: white;position: absolute;top: 0;right: 0;bottom: 0;left: 0;z-index: 9999;">
    <div>
        <p><ngb-progressbar [value]="value"></ngb-progressbar></p>
    </div>
</div> -->
<ngx-spinner></ngx-spinner>
<app-expire-token-model></app-expire-token-model>